import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './context/AuthProvider/AuthProvider';
import { AppProvider } from './context/AppContext';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

// ── MSAL instance (created once at app level) ─────────────────────────────
const msalInstance = new PublicClientApplication({
  auth: {
    clientId:    "af51e46c-ac8a-4c93-9e14-7ea6f1bd9468",
    authority:   "https://login.microsoftonline.com/3154f172-4e4d-419e-a4ab-3789feba4f99",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation:       "sessionStorage",
    storeAuthStateInCookie: false,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </AuthProvider>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();